/* eslint-disable no-lonely-if */
/* eslint-disable prefer-promise-reject-errors */
import { COMBINEDWARDCODE } from '@/hooks/useCurrentLoginUserInfo';
import { useLocales } from '@/Locales';
import { getAgencyList } from '@/services/common';
import { httpProjectPatientAuthConfig } from '@/services/patient';
import { httpGetIdentityById, httpLogin, httpRegister } from '@/services/user';
import { combinedWardFlagAtom, projectConfigAtom, userInfoAtom } from '@/store/atom';
import { setSystemUserInfo, setToken } from '@/utils/cookies';
import { message } from '@sinohealth/butterfly-ui-components';
import classNames from 'classnames';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import VConsole from 'vconsole';
import AccountForm from './components/AccountForm';
import ForgetForm from './components/ForgetForm';
import LeftBg from './components/LeftBg';
import MobileForm from './components/MobileForm';
import styles from './index.less';

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // 通过地址栏 ?debug=true 开启 vConsole 调试面板
  const debug = searchParams.get('debug');

  if (debug === 'true') {
    const vConsole = new VConsole({ theme: 'dark' });
  }
  const callbackUrl = searchParams.get('callbackUrl');
  // 从URL参数中获取redirect参数
  const redirect = searchParams.get('redirect') || '';
  const organizeId = searchParams.get('organizeId');
  const [loading, setLoading] = useState(false);
  const setUserInfo = useSetRecoilState(userInfoAtom);
  // 是否是联合病房医生
  const setCombinedWardFlag = useSetRecoilState(combinedWardFlagAtom);
  // 项目配置
  const setProjectConfig = useSetRecoilState(projectConfigAtom);
  const [loginType, setLoginType] = useState('mobile');
  const { t, changeLocales } = useLocales();

  const httpLoginReq = async (params: any, type: string = 'login') => {
    try {
      setLoading(true);
      const res: any =
        type === 'login'
          ? await httpLogin(params)
          : await httpRegister({ ...params, projectId: organizeId });
      // console.log(res);
      if (res.status === '0') {
        message.error(t('该账号已被禁用, 请联系管理员!'));
        setLoading(false);
        return;
      }
      if (res.token) {
        setToken(res.token);
        httpGetIdentityByIdReq(res.id);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (err: any) {
      console.log(err);
      if (err?.retCode !== 401) {
        message.error(err.retMsg || t('服务器出错了，请稍后再试！'));
      }
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const httpGetIdentityByIdReq = async (id: any) => {
    const userData: any = await httpGetIdentityById(id);
    const agencys = await fetchUserTeam(userData?.user?.id); // 当前用户所属机构
    const config = await httpProjectPatientAuthConfig({ id: userData?.employee?.organizeId }); // 当前用户所属机构
    const userInfoData = {
      ...userData,
      agency: agencys?.[0] || {},
      agencys: agencys || [],
      projeactConfig: config,
    };
    // console.log('当前用户信息');
    // console.log(userInfoData);
    const flag = userInfoData?.resourceCodes?.filter((item: any) =>
      COMBINEDWARDCODE.includes(item),
    );
    // console.log('是否是联合病房医生', flag);
    setCombinedWardFlag(flag?.length > 0);
    setProjectConfig(config);
    setUserInfo(userInfoData);
    setSystemUserInfo({ ...userData, projeactConfig: config });
    // httpGetDefaultAgecnyReq(res.user.id);

    console.log('登录成功，准备跳转', { callbackUrl, redirect });
    // 登录成功后的页面跳转逻辑
    if (callbackUrl) {
      // 优先使用外部回调地址
      console.log('使用 callbackUrl 跳转:', callbackUrl);
      window.location.href = decodeURIComponent(callbackUrl);
    } else if (redirect && redirect.indexOf('/login') === -1) {
      // 如果有 redirect 参数且不是登录页，则跳转回原页面
      console.log('使用 redirect 跳转:', redirect);
      navigate(redirect);
    } else {
      // 否则跳转到首页
      console.log('跳转到首页');
      navigate('/');
    }
  };

  const fetchUserTeam = (userId: any) => {
    return getAgencyList(userId).then((data: any) => {
      return data;
    });
  };

  const TabSlider = () => {
    return (
      <div className={styles.tabContainer}>
        {/* 滑动背景 */}
        <div
          className={classNames(
            styles.tabSlider,
            styles[loginType === 'mobile' ? 'slideLeft' : 'slideRight'],
          )}
        />
        <div
          className={classNames(styles.tabItem, loginType === 'mobile' ? styles.active : '')}
          onClick={() => setLoginType('mobile')}
        >
          {t('短信登录')}
        </div>
        <div
          className={classNames(styles.tabItem, loginType === 'account' ? styles.active : '')}
          onClick={() => setLoginType('account')}
        >
          {t('账号登录')}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.loginPage}>
      <LeftBg />
      <div className={styles.loginFormWrap}>
        <div className={styles.logo} />
        <div className={styles.title}>{t('欢迎登录iMDT管理平台')}</div>
        {/* 选项卡切换 */}
        {loginType !== 'forget' && TabSlider()}
        {loginType === 'account' ? (
          <AccountForm
            loading={loading}
            onLogin={httpLoginReq}
            onForget={() => setLoginType('forget')}
          />
        ) : null}
        {loginType === 'mobile' ? (
          <MobileForm
            loading={loading}
            onLogin={httpLoginReq}
            onRegister={(params) => httpLoginReq(params, 'register')}
          />
        ) : null}
        {loginType === 'forget' ? (
          <ForgetForm
            loading={loading}
            onLogin={httpLoginReq}
            onBack={() => setLoginType('account')}
          />
        ) : null}
        {loginType !== 'forget' && (
          <div className={styles.langSwitch}>
            <span onClick={() => changeLocales('zh-cn')}>中文</span> |{' '}
            <span onClick={() => changeLocales('en')}>English</span>
          </div>
        )}
      </div>
      <div className={styles.loginFooter}>
        Copyright © 2022-{new Date().getFullYear()} {t('广州中惠医疗科技有限公司')}.All rights
        reserved.{' '}
        <a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          style={{ color: '#fff', textDecoration: 'none', fontSize: 12 }}
          rel="noopener noreferrer"
        >
          粤ICP备2022019090号-1
        </a>
      </div>
    </div>
  );
};

export default Login;
